export const jobChangeIntentions = [
  {
    id: 0,
    name: 'すぐに転職したい'
  },
  {
    id: 1,
    name: '3ヶ月以内には転職したい'
  },
  {
    id: 2,
    name: '半年以内には転職したい'
  },
  {
    id: 3,
    name: '良いオファーがあれば'
  }
] as const;
